module.exports = __webpack_public_path__ + "static/media/pilar_pendidikan.e34e417e.jpg";